module.exports = __webpack_public_path__ + "img/profession.30af021e.png";